export default __webpack_public_path__ + "static/media/barakahhijama.b15295f3.gif";